import * as React from "react";
export var componentFromType = function (ComponentType) {
    return ComponentType && React.createElement(ComponentType, null);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/componentFromType.tsx
// module id = 305
// module chunks = 3